import React from 'react'
import TenantMaintenace from '../Components/Maintenace/Tenant/TenantMaintenace'

const MaintenaceTenantPage = () => {
  return (
    <TenantMaintenace />
  )
}

export default MaintenaceTenantPage